import { createReducer } from 'redux-act';
import { fetchSearchResultsSuccess, fetchSearchResultsFailure, setLoading, fetchSearchResults, clearResults } from './searchActions';

const initialState = {
  results: [],
  meta: {},
  isLoading: true,
  error: null,
};

export const reducer = createReducer(
  {
    [fetchSearchResults]: (state) => ({ ...state, error: null }),
    [fetchSearchResultsSuccess]: (state, { results, meta }) => ({ ...state, results, meta }),
    [fetchSearchResultsFailure]: (state, error) => ({ ...state, results: [], meta: {}, error }),
    [clearResults]: (state) => ({ ...state, results: [], meta: {} }),
    [setLoading]: (state, payload) => ({ ...state, isLoading: payload }),
  },
  initialState,
);
